/* 
 * Export component file to be used on project
*/

import ModalRepproveRequest from './ModalRepproveRequest.js';
export default ModalRepproveRequest;
